import { styled } from '@linaria/react'
import { PrimaryButton } from 'atoms/Button/Templates'

export const ShoppingCartRedirectButtonSC = styled(PrimaryButton)`
  min-width: 217px;
`
